import React, { useEffect, useRef, useState } from "react";
import "./Styles/GetInvolved.css";
import linkedIn from "./Logos/linkedin.png";
import discord from "./Logos/discord.png";
import { getFormSubmitUrl, postFormJson } from "./formSubmitUrl";

const INITIAL_GET_INVOLVED = {
    name: "",
    email: "",
    university: "",
    team: [],
    fitReason: "",
    comments: "",
};

function GetInvolved() {
    const [formData, setFormData] = useState(INITIAL_GET_INVOLVED);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const thanksRef = useRef(null);

    useEffect(() => {
        if (!submitSuccess) return;
        thanksRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, [submitSuccess]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            setFormData((prevData) => ({
                ...prevData,
                team: checked
                    ? [...prevData.team, value]
                    : prevData.team.filter((team) => team !== value),
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const { response, data } = await postFormJson(getFormSubmitUrl(), {
                ...formData,
                formSource: "get-involved",
            });
            if (response.ok) {
                setFormData(INITIAL_GET_INVOLVED);
                setSubmitSuccess(true);
            } else {
                alert(data.message || "Error submitting form");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while submitting the form.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubmitAnother = () => {
        setFormData(INITIAL_GET_INVOLVED);
        setSubmitSuccess(false);
    };

    return (
        <div className="get-involved-page">
            <h1>GET INVOLVED</h1>
            <div className="form-container">
                {submitSuccess ? (
                    <div ref={thanksRef} className="form-thanks" role="status" aria-live="polite">
                        <h2 className="form-thanks-title">Thanks for your interest</h2>
                        <p className="form-thanks-body">
                            A member of our team will contact you shortly to discuss your skills and how you can contribute. You will also receive a
                            confirmation email — if it does not arrive within a few minutes, check your spam or junk folder.
                        </p>
                        <button type="button" className="submit-button form-thanks-action" onClick={handleSubmitAnother}>
                            Submit another response
                        </button>
                    </div>
                ) : (
                <form className="join-form" onSubmit={handleSubmit}>
                    <label htmlFor="name">Name:</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="email">Email (University email preferred):</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="university">What university do you attend?</label>
                    <input
                        type="text"
                        id="university"
                        name="university"
                        value={formData.university}
                        onChange={handleChange}
                        required
                    />

                    <label>What team are you looking forward to joining?</label>
                    <div className="checkbox-group">
                        <label>
                            <input
                                type="checkbox"
                                name="team"
                                value="Electrical"
                                checked={formData.team.includes("Electrical")}
                                onChange={handleChange}
                            />{" "}
                            Electrical
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                name="team"
                                value="Mechanical"
                                checked={formData.team.includes("Mechanical")}
                                onChange={handleChange}
                            />{" "}
                            Mechanical
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                name="team"
                                value="Software"
                                checked={formData.team.includes("Software")}
                                onChange={handleChange}
                            />{" "}
                            Software
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                name="team"
                                value="Management"
                                checked={formData.team.includes("Management")}
                                onChange={handleChange}
                            />{" "}
                            Management
                        </label>
                    </div>

                    <label htmlFor="fitReason">
                        Why do you think you are a good fit for the Dalhousie Combat Robotics Team? (Hint: past
                        experiences or relevant skills)
                    </label>
                    <textarea
                        id="fitReason"
                        name="fitReason"
                        value={formData.fitReason}
                        onChange={handleChange}
                        rows="4"
                        required
                    ></textarea>

                    <label htmlFor="comments">Any additional comments:</label>
                    <textarea
                        id="comments"
                        name="comments"
                        value={formData.comments}
                        onChange={handleChange}
                        rows="3"
                    ></textarea>

                    <button type="submit" className="submit-button" disabled={isSubmitting}>
                        {isSubmitting ? "Sending…" : "Submit"}
                    </button>
                </form>
                )}

                <div className="social-icons">
                    <a
                        href="https://discord.gg/e6pkNf78"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon-link"
                    >
                        <img src={discord} alt="Discord" className="social-icon" />
                    </a>

                    <a
                        href="https://www.linkedin.com/company/dalhousie-combat-robotics-team/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon-link"
                    >
                        <img src={linkedIn} alt="LinkedIn" className="social-icon" />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default GetInvolved;
